"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = customTranslate;
require("core-js/modules/es6.regexp.replace");
var _zh = _interopRequireDefault(require("../lang/zh"));
function customTranslate(template, replacements) {
  replacements = replacements || {};

  // Translate
  template = _zh.default[template] || template;

  // Replace
  return template.replace(/{([^}]+)}/g, function (_, key) {
    var str = replacements[key];
    if (_zh.default[replacements[key]] !== null && _zh.default[replacements[key]] !== 'undefined') {
      str = _zh.default[replacements[key]];
    }
    return str || '{' + key + '}';
  });
}